import React, { useContext } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import _ from 'lodash';

import Typography from 'components/Main/Typography';
import PairCell from '../PairCell';
import ManagementDetailedInformationsContext from 'context/ManagementDetailedInformationsContext';
import { roundTo2 } from 'utils/helpers';

const SimpleRow = React.forwardRef(({ row, disabled, changes }, ref) => {
	const { formData } = useContext(ManagementDetailedInformationsContext);

	let showTotalExpensesError = false;
	let showExpenditureIncurredError = false;
	if (row.name === 'indirect_costs') {
		const totalExpensesParts = [
			+ roundTo2(formData.table3.total_remuneration?.total_expenses)
			+ roundTo2(formData.table3.organization?.total_expenses)
			+ roundTo2(formData.table3.financing_agreements?.total_expenses)
			+ roundTo2(formData.table3.wib_management?.total_expenses)
			+ roundTo2(formData.table3.commercialization?.sum?.total_expenses)
			+ roundTo2(formData.table3.stamp_duties?.total_expenses)
			+ roundTo2(formData.table3.information_activities?.total_expenses)
			+ roundTo2(formData.table3.other_direct_costs?.total_expenses)
		];
		const expenditureIncurredParts = [
			+ roundTo2(formData.table3.total_remuneration?.expenditure_incurred)
			+ roundTo2(formData.table3.organization?.expenditure_incurred)
			+ roundTo2(formData.table3.financing_agreements?.expenditure_incurred)
			+ roundTo2(formData.table3.wib_management?.expenditure_incurred)
			+ roundTo2(formData.table3.commercialization?.sum?.expenditure_incurred)
			+ roundTo2(formData.table3.stamp_duties?.expenditure_incurred)
			+ roundTo2(formData.table3.information_activities?.expenditure_incurred)
			+ roundTo2(formData.table3.other_direct_costs?.expenditure_incurred)
		];
		const totalExpensesValue = roundTo2(formData.table3.indirect_costs.total_expenses);
		const expenditureIncurredValue = roundTo2(formData.table3.indirect_costs.expenditure_incurred);

		showTotalExpensesError = totalExpensesValue > roundTo2(_.sum(totalExpensesParts) * 0.15);
		showExpenditureIncurredError = expenditureIncurredValue > roundTo2(_.sum(expenditureIncurredParts) * 0.15);
	}

	return (
		<TableRow key={row.name} ref={ref}>
			<TableCell>{row.label}</TableCell>
			<PairCell
				sumName={`table3.${row.name}.total_expenses`}
				inputName={`table3.${row.name}.expenditure_incurred`}
				disabled={disabled}
				sumChildren={
					showTotalExpensesError ? (
						<Typography variant="inputStatus" color="error">
							UWAGA! Wartość nie może przekraczać łącznie 15%
						</Typography>
					) : null
				}
				inputChildren={
					showExpenditureIncurredError ? (
						<Typography variant="inputStatus" color="error">
							UWAGA! Wartość nie może przekraczać 15% w okresie bieżącym
						</Typography>
					) : null
				}
			/>
			<PairCell
				sumName={`table3.${row.name}.total_approved`}
				inputName={`table3.${row.name}.approved_expenses`}
				disabled={disabled}
				hidden={changes.hide_approved_expenditure_columns_20251201}
			/>
		</TableRow>
	);
});
SimpleRow.displayName = 'SimpleRow';

export default SimpleRow;
